import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'

import ComplexTextInput from '../ComplexTextInput';
import DeleteButton from '../../buttons/DeleteButton';
import useStyles from './styles';
import SecondaryButton from '../../buttons/SecondaryButton';
import { videoLocationUrl } from '../../../../config';


const CodeFromServer = ({ value, reset, type }) => {
  const { t } = useTranslation(['translation']);
  const classes = useStyles();
  const videoURL = value ? `${videoLocationUrl}${value}/video.low.mp4` : '';

  return (
    <div className={classes.codeContainer}>
      <div className={classes.inputContainer}>
        <ComplexTextInput
          id="videoForUpload"
          title={t('CAMPAIGN.VIDEO_UPLOADER.VIDEO_LABEL')}
          value={value}
          iconName="video"
          disabled
          altClasses={{ container: classes.textInputContainer }}
        />
        <div className={classes.button}>
          <DeleteButton onClick={reset} />
        </div>
      </div>
      {type === 'Video' && (
        <div className={classes.shortContainer}>
          <SecondaryButton 
            type="button" 
            onClick={() => window.open(videoURL, '_blank')}
            className={classes.submitVideoBtn}
          >
            {t('CAMPAIGN.VIDEO_UPLOADER.BUTTON_PREVIEW_TEXT')}
          </SecondaryButton>
        </div>
      )}
    </div>
  );
};


CodeFromServer.propTypes = {
  value: PropTypes.string.isRequired,
  reset: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default CodeFromServer;
